import Icon from 'shared/icons';

export interface INavList {
	name: string;
	header?: string;
	icon: JSX.Element;
	url: string;
	include: string;
	open: boolean;
	_onClick?: () => void;
}

export const nav_list: INavList[] = [
	{
		name: '추천 크리에이터',
		header: '입점 브랜드 추천',
		icon: <Icon.AutoAwesome />,
		url: `/recommend`,
		include: `/recommend`,
		open: true,
	},
	{
		name: '협업 크리에이터',
		header: '입점 브랜드 협업',
		icon: <Icon.Video />,
		url: `/creator`,
		include: `/creator`,
		open: true,
	},
];
